enum CommonStatus {
    Covered,
    CoveredOutsideClinic,
    CoveredWithGroup,
    CoveredWithAnotherGroup,
    NotCovered,
    Question,
    NoInfo,
    Terminated
}

export { CommonStatus };
